import React from 'react';
import { ArrowLeft, Download, Printer } from 'lucide-react';
import { Badge } from '../../../ui/badge';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';

interface DetailHeaderProps {
  submission: CreditSubmission;
  onBack: () => void;
  onPrint: () => void;
  onDownload: () => void;
}

const getStatusBadge = (status: string) => {
  const statusConfig: Record<string, { label: string; className: string }> = {
    draft: { label: 'Draft', className: 'bg-gray-100 text-gray-700' },
    submitted: { label: 'Menunggu Approval', className: 'bg-amber-100 text-amber-700' },
    reviewed: { label: 'Direview', className: 'bg-blue-100 text-blue-700' },
    approved: { label: 'Disetujui', className: 'bg-green-100 text-green-700' },
    rejected: { label: 'Ditolak', className: 'bg-red-100 text-red-700' },
  };

  const config = statusConfig[status] || statusConfig.draft;
  return <Badge className={config.className}>{config.label}</Badge>;
};

export default function DetailHeader({
  submission,
  onBack,
  onPrint,
  onDownload,
}: DetailHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors no-print"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Detail Pengajuan Kredit</h1>
          <p className="text-gray-500 mt-1">{submission.submission_number}</p>
        </div>
      </div>
      <div className="flex items-center gap-3 no-print">
        {getStatusBadge(submission.status)}
        <button
          onClick={onDownload}
          className="px-4 py-2 border rounded-lg hover:bg-gray-50 flex items-center gap-2 transition-colors"
        >
          <Download className="w-4 h-4" />
          Unduh
        </button>
        <button
          onClick={onPrint}
          className="px-4 py-2 border rounded-lg hover:bg-gray-50 flex items-center gap-2 transition-colors"
        >
          <Printer className="w-4 h-4" />
          Cetak
        </button>
      </div>
    </div>
  );
}
